import { render, staticRenderFns } from "./FairTowers.vue?vue&type=template&id=aeae156e&scoped=true"
import script from "./FairTowers.vue?vue&type=script&lang=js"
export * from "./FairTowers.vue?vue&type=script&lang=js"
import style0 from "./FairTowers.vue?vue&type=style&index=0&id=aeae156e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeae156e",
  null
  
)

export default component.exports